// API Configuration
export const API_CONFIG = {
    development: 'http://3.106.188.219:5000/api/v1/',
    production: 'https://api-member-v2.sakuraxx.com/api/v1/'
};
export const getApiUrl = () => {
    // Use environment variable if available
    if (process.env.VUE_APP_API_BASE_URL) {
        return process.env.VUE_APP_API_BASE_URL;
    }
    // Otherwise, check if we're in production based on hostname
    const isProduction = process.env.NODE_ENV === 'production' ||
        window.location.hostname.includes('u2xx.com') ||
        window.location.hostname.includes('sakuraxx.com');
    return isProduction ? API_CONFIG.production : API_CONFIG.development;
};
export const API_ENDPOINTS = {
    // Auth endpoints
    login: 'auth',
    logout: 'auth/logout',
    verifyToken: 'verify',
    // Booking endpoints
    createBooking: 'bookings',
    getBookings: 'bookings',
    getBooking: (id) => `bookings/${id}`,
    updateBooking: (id) => `bookings/${id}`,
    deleteBooking: (id) => `bookings/${id}`,
    // Customer endpoints
    getCustomers: 'customers',
    createCustomer: 'customers',
    getCustomer: (id) => `customers/${id}`,
    updateCustomer: (id) => `customers/${id}`,
    // Shop endpoints
    getShops: 'shops',
    getShop: (id) => `shops/${id}`
};
